import * as React from 'react';

import Code16 from './Code16';

export const code16 = () => <Code16 />;

export default {
    title: 'Icon|Fill|Code16',
    component: Code16,
    parameters: {
        notes: "`import Code16 from 'box-ui-elements/es/icon/fill/Code16';`",
    },
};
